import React, { useState, useEffect } from 'react'
import './Testimonial.css'
import TestmonialCard from "./TestmonialCard";
import axios from 'axios'
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { tes_timonial, API_URL } from '../../constants'

export default function Testimonial() {
    SwiperCore.use([Navigation, Pagination, Scrollbar, A11y]);
    const [testimonial, setTestimonial] = useState([])
    useEffect(() => {
        axios.get(API_URL + '/testimentals')
            .then(res => {
                setTestimonial(res.data)
            })
    }, [])

    const tcards = testimonial.map(t => (<TestmonialCard author={t.author} statement={t.statement} photo_url={t.photo_url} key={t._id} />))
    console.log(testimonial);
    return (
        <div className='testimonial__wrapper'  >
            <h1 className={"heading_section"}>{tes_timonial.title}</h1>
            <div className='testimonial'>
                {tcards}
            </div>
       
        </div>
    )
}
